// extracted by mini-css-extract-plugin
export default {"content":"Notab_content__DRAPi","phone":"Notab_phone__4qzJe","test":"Notab_test__CR8uf"};